import { render, staticRenderFns } from "./CpvSelector.vue?vue&type=template&id=38782738&scoped=true"
import script from "./CpvSelector.vue?vue&type=script&lang=js"
export * from "./CpvSelector.vue?vue&type=script&lang=js"
import style0 from "./CpvSelector.vue?vue&type=style&index=0&id=38782738&prod&scoped=true&lang=css"
import style1 from "./CpvSelector.vue?vue&type=style&index=1&id=38782738&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38782738",
  null
  
)

export default component.exports